export const MEMBERSHIP_MARK_TEST_ID = 'membership-mark'

export const SIDEBAR_SEARCH_RESULTS_TEST_ID = 'sidebar-search-results'

export const SIDEBAR_PARENT_GROUP_TEST_ID = 'sidebar-parent-group'

export const SIDEBAR_PINNED_LIST_TEST_ID = 'sidebar-pinned-list'

export const SIDEBAR_GROUPS_LIST_TEST_ID = 'sidebar-groups-list'

export const SIDEBAR_USERS_LIST_TEST_ID = 'sidebar-users-list'

export const SIDEBAR_ITEM_EXPAND_BUTTON_TEST_ID = 'sidebar-item-expand-button'

export const SIDEBAR_SEARCH_TEST_ID = 'sidebar-search'

export const HOMEPAGE_WORKSPACES_FILTER_TEST_ID = 'workspaces-filter'

export const HOMEPAGE_INTERVAL_FILTER_TEST_ID = 'homepage-interval-filter'

export const HOMEPAGE_STATUS_FILTER_TEST_ID = 'homepage-status-filter'

export const SIDEBAR_FILTER_BY_SWITCH_TEST_ID = 'sidebar-filter-by-switch'

export const SIDEBAR_GROUPS_FILTER_TEST_ID = 'sidebar-groups-filter'

export const SIDEBAR_USERS_FILTER_TEST_ID = 'sidebar-users-filter'

export const SIDEBAR_ITEM_TEST_ID = 'sidebar-item'

export const SIDEBAR_ITEM_NAME_TEST_ID = 'sidebar-item-name'

export const SIDEBAR_UNPIN_BUTTON_TEST_ID = 'sidebar-unpin-button'

export const SIDEBAR_LEVEL_UP_BUTTON_TEST_ID = 'sidebar-level-up-button'

export const SIDEBAR_PINNED_ITEM_DRAG_HANDLE_TEST_ID = 'sidebar-pinned-item-drag-handle'

export const SIDEBAR_EMPTY_STATE_TEST_ID = 'sidebar-empty-state'

export const HOMEPAGE_FULLSCREEN_BUTTON_TEST_ID = 'homepage-fullscreen-button'

export const HOMEPAGE_PIN_BUTTON_TEST_ID = 'homepage-pin-button'

export const HOMEPAGE_SHARE_BUTTON_TEST_ID = 'homepage-share-button'

export const HOMEPAGE_WORKSPACES_FILTER_OPTION_TEST_ID = 'homepage-workspaces-filter-option'

export const HOMEPAGE_INTERVAL_FILTER_OPTION_TEST_ID = 'homepage-interval-filter-option'

export const HOMEPAGE_INTERVAL_FILTER_COUNTER_TEST_ID = 'homepage-interval-filter-counter'

export const HOMEPAGE_CUSTOM_RANGE_PICKER_TRIGGER_TEST_ID = 'custom-range-picker-trigger'

export const HOMEPAGE_AVERAGE_PROGRESS_TEST_ID = 'homepage-average-progress'

export const HOMEPAGE_AVERAGE_PROGRESS_NAME_TEST_ID = 'homepage-average-progress-name'

export const HOMEPAGE_AVERAGE_PROGRESS_VALUE_TEST_ID = 'homepage-average-progress-value'

export const HOMEPAGE_TABS_TEST_ID = 'homepage-tabs'

export const HOMEPAGE_OBJECTIVES_CARD_TEST_ID = 'homepage-objectives-card'

export const HOMEPAGE_KEY_RESULTS_CARD_TEST_ID = 'homepage-key-results-card'

export const HOMEPAGE_STAKEHOLDERS_CARD_TEST_ID = 'homepage-stakeholders-card'

export const HOMEPAGE_CARD_VIEW_SWITCH_TEST_ID = 'homepage-card-view-switch'

export const HOMEPAGE_ELEMENTS_PROGRESS_TEST_ID = 'homepage-elements-progress'

export const HOMEPAGE_ELEMENTS_PROGRESS_VALUE_TEST_ID = 'homepage-elements-progress-value'

export const HOMEPAGE_ELEMENTS_PROGRESS_GAP_TEST_ID = 'homepage-elements-progress-gap'

export const HOMEPAGE_CHECKINS_FEED_TEST_ID = 'homepage-checkins-feed'

export const HOMEPAGE_DASHBOARD_TEST_ID = 'homepage-dashboard'

export const HOMEPAGE_DASHBOARD_EMPTY_STATE_TEST_ID = 'homepage-dashboard-empty-state'

export const HOMEPAGE_AI_REPORTS_TEST_ID = 'homepage-ai-reports'

export const HOMEPAGE_AI_REPORTS_SLOT_PROBE_TEST_ID = 'homepage-ai-reports-slot-probe'

export const HOMEPAGE_AVERAGE_PROGRESS_FIGURES_LOADER_TEST_ID =
  'homepage-average-progress-figures-loader'

export const HOMEPAGE_ALIGNMENT_FIGURE_TEST_ID = 'homepage-alignment-figure'

export const HOMEPAGE_ALIGNMENT_FIGURE_VALUE_TEST_ID = 'homepage-alignment-figure-value'

export const HOMEPAGE_ALIGNMENT_FIGURE_BAR_TEST_ID = 'homepage-alignment-figure-bar'

export const HOMEPAGE_ENGAGEMENT_FIGURE_TEST_ID = 'homepage-engagement-figure'

export const HOMEPAGE_ENGAGEMENT_FIGURE_VALUE_TEST_ID = 'homepage-engagement-figure-value'

export const HOMEPAGE_AI_REPORT_DEBUG_BUTTON_TEST_ID = 'homepage-ai-report-debug-button'

export const HOMEPAGE_AI_REPORT_DEBUG_DIALOG_TEST_ID = 'homepage-ai-report-debug-dialog'

export const HOMEPAGE_AI_REPORT_DEBUG_DIALOG_LOADER_TEST_ID =
  'homepage-ai-report-debug-dialog-loader'

export const HOMEPAGE_AI_REPORT_DEBUG_DIALOG_FORBIDDEN_TEST_ID =
  'homepage-ai-report-debug-dialog-forbidden'

export const HOMEPAGE_AI_REPORT_DEBUG_SETTINGS_TEST_ID = 'homepage-ai-report-debug-settings'

export const HOMEPAGE_AI_REPORT_DEBUG_MODEL_SELECT_TEST_ID = 'homepage-ai-report-debug-model-select'

export const HOMEPAGE_AI_REPORT_DEBUG_EFFORT_SELECT_TEST_ID =
  'homepage-ai-report-debug-effort-select'

export const HOMEPAGE_AI_REPORT_DEBUG_TIME_LIMIT_INPUT_TEST_ID =
  'homepage-ai-report-debug-time-limit-input'

export const HOMEPAGE_AI_REPORT_DEBUG_PAIRS_PER_CALL_INPUT_TEST_ID =
  'homepage-ai-report-debug-pairs-per-call-input'

export const HOMEPAGE_AI_REPORT_DEBUG_ELEMENTS_PER_CALL_INPUT_TEST_ID =
  'homepage-ai-report-debug-elements-per-call-input'

export const HOMEPAGE_AI_REPORT_DEBUG_SYSTEM_PROMPT_TEST_ID =
  'homepage-ai-report-debug-system-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_USER_PROMPT_TEST_ID = 'homepage-ai-report-debug-user-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_SUMMARY_SYSTEM_PROMPT_TEST_ID =
  'homepage-ai-report-debug-summary-system-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_SUMMARY_USER_PROMPT_TEST_ID =
  'homepage-ai-report-debug-summary-user-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_SAVE_BUTTON_TEST_ID = 'homepage-ai-report-debug-save-button'

export const HOMEPAGE_AI_REPORT_DEBUG_CLEAR_BUTTON_TEST_ID = 'homepage-ai-report-debug-clear-button'

export const HOMEPAGE_AI_REPORT_DEBUG_CALLS_TEST_ID = 'homepage-ai-report-debug-calls'

export const HOMEPAGE_AI_REPORT_DEBUG_CALLS_LOADER_TEST_ID = 'homepage-ai-report-debug-calls-loader'

export const HOMEPAGE_AI_REPORT_DEBUG_CALLS_EMPTY_TEST_ID = 'homepage-ai-report-debug-calls-empty'

export const HOMEPAGE_AI_REPORT_DEBUG_TOTAL_COST_TEST_ID = 'homepage-ai-report-debug-total-cost'

export const HOMEPAGE_AI_REPORT_DEBUG_GENERATION_TEST_ID = 'homepage-ai-report-debug-generation'

export const HOMEPAGE_AI_REPORT_DEBUG_GENERATION_COST_TEST_ID =
  'homepage-ai-report-debug-generation-cost'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_TEST_ID = 'homepage-ai-report-debug-call'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_OUTCOME_TEST_ID = 'homepage-ai-report-debug-call-outcome'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_COST_TEST_ID = 'homepage-ai-report-debug-call-cost'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_SYSTEM_PROMPT_TEST_ID =
  'homepage-ai-report-debug-call-system-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_USER_PROMPT_TEST_ID =
  'homepage-ai-report-debug-call-user-prompt'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_ANSWER_TEST_ID = 'homepage-ai-report-debug-call-answer'

export const HOMEPAGE_AI_REPORT_DEBUG_CALL_NO_ANSWER_TEST_ID =
  'homepage-ai-report-debug-call-no-answer'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_TEST_ID = 'homepage-alignment-report-dialog'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_SELECTION_NAME_TEST_ID =
  'homepage-alignment-report-dialog-selection-name'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_GENERATING_TEST_ID =
  'homepage-alignment-report-dialog-generating'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_SPINNER_TEST_ID =
  'homepage-alignment-report-dialog-spinner'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_FILTERS_TEST_ID =
  'homepage-alignment-report-dialog-filters'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_FILTERS_INTERVAL_TEST_ID =
  'homepage-alignment-report-dialog-filters-interval'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_GENERATED_AT_TEST_ID =
  'homepage-alignment-report-dialog-generated-at'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_EMPTY_STATE_TEST_ID =
  'homepage-alignment-report-dialog-empty-state'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_STATUS_MESSAGE_TEST_ID =
  'homepage-alignment-report-dialog-status-message'

export const HOMEPAGE_ALIGNMENT_REPORT_DIALOG_RECALCULATE_BUTTON_TEST_ID =
  'homepage-alignment-report-dialog-recalculate-button'

export const HOMEPAGE_AI_ALIGNMENT_REPORT_TEST_ID = 'homepage-ai-alignment-report'

export const HOMEPAGE_AI_ALIGNMENT_SECTION_TEST_ID = 'homepage-ai-alignment-section'

export const HOMEPAGE_AI_ALIGNMENT_SECTION_HEADING_TEST_ID = 'homepage-ai-alignment-section-heading'

export const HOMEPAGE_AI_ALIGNMENT_ROW_TEST_ID = 'homepage-ai-alignment-row'

export const HOMEPAGE_AI_ALIGNMENT_PARENT_TEST_ID = 'homepage-ai-alignment-parent'

export const HOMEPAGE_AI_ALIGNMENT_ELEMENT_ICON_TEST_ID = 'homepage-ai-alignment-element-icon'

export const HOMEPAGE_AI_ALIGNMENT_PARENT_SCORE_TEST_ID = 'homepage-ai-alignment-parent-score'

export const HOMEPAGE_AI_ALIGNMENT_CHILD_TEST_ID = 'homepage-ai-alignment-child'

export const HOMEPAGE_AI_ALIGNMENT_CHILD_SCORE_TEST_ID = 'homepage-ai-alignment-child-score'

export const HOMEPAGE_AI_ALIGNMENT_SCORE_TEST_ID = 'homepage-ai-alignment-score'

export const HOMEPAGE_AI_ALIGNMENT_NO_PARENT_TEST_ID = 'homepage-ai-alignment-no-parent'

export const HOMEPAGE_AI_ALIGNMENT_RECOMMENDATION_TEST_ID = 'homepage-ai-alignment-recommendation'

export const HOMEPAGE_AI_ALIGNMENT_RECOMMENDATION_ELEMENT_TEST_ID =
  'homepage-ai-alignment-recommendation-element'

export const HOMEPAGE_AI_ALIGNMENT_RECOMMENDATION_CRITERION_TEST_ID =
  'homepage-ai-alignment-recommendation-criterion'

export const HOMEPAGE_AI_ALIGNMENT_RECOMMENDATION_TEXT_TEST_ID =
  'homepage-ai-alignment-recommendation-text'

export const HOMEPAGE_AI_ALIGNMENT_MASKED_ELEMENT_TEST_ID = 'homepage-ai-alignment-masked-element'

export const HOMEPAGE_AI_ALIGNMENT_WEAKEST_PAIRS_NOTE_TEST_ID =
  'homepage-ai-alignment-weakest-pairs-note'

export const HOMEPAGE_AI_ALIGNMENT_NO_PAIRS_TEST_ID = 'homepage-ai-alignment-no-pairs'

export const HOMEPAGE_AI_ALIGNMENT_SUMMARY_TEST_ID = 'homepage-ai-alignment-summary'

export const HOMEPAGE_AI_ALIGNMENT_OVERALL_SCORE_TEST_ID = 'homepage-ai-alignment-overall-score'

export const HOMEPAGE_AI_ENGAGEMENT_REPORT_TEST_ID = 'homepage-ai-engagement-report'

export const HOMEPAGE_AI_ENGAGEMENT_FIGURE_TEST_ID = 'homepage-ai-engagement-figure'

export const HOMEPAGE_AI_ENGAGEMENT_ROW_TEST_ID = 'homepage-ai-engagement-row'

export const HOMEPAGE_AI_ENGAGEMENT_EMPTY_ROW_TEST_ID = 'homepage-ai-engagement-empty-row'

export const HOMEPAGE_AI_ENGAGEMENT_OWNER_TEST_ID = 'homepage-ai-engagement-owner'

export const HOMEPAGE_AI_ENGAGEMENT_ELEMENTS_TEST_ID = 'homepage-ai-engagement-elements'

export const HOMEPAGE_AI_ENGAGEMENT_CHECKINS_TEST_ID = 'homepage-ai-engagement-checkins'

export const HOMEPAGE_AI_ENGAGEMENT_LAST_UPDATE_TEST_ID = 'homepage-ai-engagement-last-update'

export const HOMEPAGE_AI_ENGAGEMENT_RATE_TEST_ID = 'homepage-ai-engagement-rate'

export const HOMEPAGE_AI_ENGAGEMENT_NO_OWNERS_TEST_ID = 'homepage-ai-engagement-no-owners'

export const HOMEPAGE_AI_ENGAGEMENT_COMMENTARY_LINE_TEST_ID =
  'homepage-ai-engagement-commentary-line'

export const HOMEPAGE_AI_ENGAGEMENT_COMMENTARY_NOTE_TEST_ID =
  'homepage-ai-engagement-commentary-note'
